import { axiosApiInstance } from './axios';

// -------------------------------------------------------------

const apiRoot = '';

const authenticationActivityApi = {
  // GET
  get: async (params) => {
    try {
      const res = await axiosApiInstance.get(`${apiRoot}/authenticationActivity`, { params });

      return res;
    } catch (e: any) {
      return e.response;
    }
  },

  // PUT
  update: async (data, id) => {
    try {
      const res = await axiosApiInstance.put(`${apiRoot}/authenticationActivity/${id}`, data);

      return res;
    } catch (e: any) {
      return e.response;
    }
  },

  updateStatus: async (data, id) => {
    try {
      const res = await axiosApiInstance.put(`${apiRoot}/authenticationActivity/status/${id}`, data);

      return res;
    } catch (e: any) {
      return e.response;
    }
  },

  delete: async (id) => {
    try {
      const res = await axiosApiInstance.delete(`${apiRoot}/authenticationActivity/${id}`);

      return res;
    } catch (e: any) {
      return e.response;
    }
  },
};

export default authenticationActivityApi;
